<script setup lang="ts">
	import {msg} from "@/i18n/Message.ts";
	import {ref, computed} from 'vue';
	import ErrorMsg from "./ErrorMsg.vue";
	import { useBaseStep } from './BaseStep';
	import SymIcon from "@fd/helpers/SymIcon.vue";
	import ProgressButton from "./ProgressButton.vue";
	
	const emit = defineEmits(['nextStep', 'updateForm','reload']);
	const props = defineProps({
		form: Object,
		restApi: String,
		endPoint: { type: String, default: "/upgrade" }
	});
	const { errorMessage, isError, progress, submitOnEnter,
			sendForm, nextStep, errEmptyStringClass  } = useBaseStep(props,emit,validateForm);
	
	function validateForm(): boolean {
		if (!Boolean(props.form.oldPath)) {
			errorMessage.value=msg("install.form.errorValues");
			return false;
		}
		return true;
	}
	
	function onSubmit(): void {
		sendForm(props.form,'Database');
	}
</script>
<template>
	<div>
	<div class="formTitle">{{msg("install.title.oldPath")}}</div>
	<form @submit.prevent>
		<table border="0" cellspacing="0" class="formTable">
			<tr>
				<th>{{msg("install.upgrade.path")}}:</th>
				<td><input type="text" name="upgradePath" :value="form.oldPath" tabindex="10" size="60" @keypress="submitOnEnter($event,onSubmit)"
						@input="$emit('updateForm', 'oldPath', $event.target.value)" :class="errEmptyStringClass(form.oldPath)"></td>
			</tr>
			<tr>
				<td colspan="2"><error-msg :show="isError" :msg="errorMessage"/></td>
			</tr>
			<tr>
				<td colspan="2" style="padding-top:20px">
					<button @click="nextStep('Selection')" class="sbutton" tabindex="30">
						<sym-icon name="page-prev-16-full" style="padding-right: 10px;"/>{{msg("install.butt.back")}}
					</button>
					&nbsp;
					<progress-button @click="onSubmit" tabindex="20" :progress="progress"
						class="button" icon="page-next-16-full">
						{{msg('install.butt.next')}}
					</progress-button>
				</td>
			</tr>
		</table>
	</form>
	</div>
</template>
